@if (socialLinks()) {
  <nav class="social-links" [class.align-start]="alignment() === 'start'">
    <div class="social-links-container">
      <ul
        *transloco="let t; prefix: 'social-links'"
        [attr.aria-label]="ariaLabel()"
        [class.align-start]="alignment() === 'start'">
        @if (socialLinks().linkedin) {
          <li (click)="socialNetworkClicked.emit('linkedin')">
            <a
              [href]="socialLinks().linkedin"
              [attr.aria-label]="t('linkedin', { name: name() })"
              class="linkedin"
              target="_blank">
              <accredible-icon icon="linkedin1" />
            </a>
          </li>
        }

        @if (socialLinks().twitter) {
          <li>
            <a
              [href]="twitterLink()"
              [attr.aria-label]="t('x', { name: name() })"
              (click)="socialNetworkClicked.emit('twitter')"
              class="twitter"
              target="_blank">
              <accredible-icon icon="x" />
            </a>
          </li>
        }
        @if (showAdditionalLinks()) {
          @for (socialMedia of additionalSocialMedia(); track socialMedia.provider) {
            <li>
              <a
                class="additional-social-link"
                target="_blank"
                [href]="socialMedia.url"
                (click)="socialNetworkClicked.emit(socialMedia.provider)">
                <accredible-chip [data]="socialMedia.displayName" />
              </a>
            </li>
          }
        }
      </ul>
    </div>
  </nav>
}
